import { makeStyles } from "@material-ui/core/styles";
var useStyles = makeStyles({
    root: {
        margin: 2,
        borderRadius: 5,
        height: 25,
    },
    label: {
        maxWidth: '150px',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        display: 'inline-block',
    }
});
var labelStyles = makeStyles({
    editIcon: {
        position: 'relative',
        top: '8px',
        left: '4px'
    },
    searchField: {
        width: '100%'
    },
    choicePanel: {
        border: 'solid 1px black',
        height: '350px',
        width: '250px',
        overflowY: 'auto'
    },
    transferButton: {
        marginBottom: '10px'
    }
});
export { useStyles, labelStyles };
//# sourceMappingURL=style.js.map